export default {
    memberDataSection: {
        import: "Impor",
        buyingStation: "Stasiun Pembelian",
        continue: "Lanjutkan",
        farmerId: "ID Petani",
        farmerName: "Nama Petani",
        farmerAddress: "Alamat Petani",
        quality: "Kualitas",
        quantity: "Kuantitas",
        importAll: "Impor Semua",
        importSelected: "Impor yang Dipilih",
        fileLoaded: "Berkas berhasil dimuat",
        incorrectHeaders: "Header salah",
        processingBatch: "Memproses Batch",
        purchaseOrder: "Pesanan Pembelian",
        startDate: "Tanggal Mulai",
        endDate: "Tanggal Akhir",
        purchasingOrder: "Pesanan Pembelian",
        totalCoffeeCherry: "Total Biji Kopi Cherry",
        airHumidity: "Kelembapan Udara",
        density: "Kepadatan",
        temperature: "Suhu",
        beanMoistureContent: "Kandungan Air Biji Kopi",
        processType: "Jenis Proses",
        batchRating: "Pilih Rating Batch",
        purchaseDate: "Tanggal Pembelian",
        selectFarmer: "Pilih Petani",
        selectFarm: "Pilih Peternakan",
        selectPlantation: "Pilih Perkebunan",
        coffeeVariety: "Varietas Kopi",
        coffeeSpecies: "Spesies Kopi",
        coffeeCherryQuantity: "Kuantitas Biji Kopi Cherry",
        coffeeCherryQuality: "Kualitas Biji Kopi Cherry",
        coffeeType: "Tipe Kopi",
        pricePerKg: "Harga Per Kg",
        processingDone: "Pengolahan Selesai",
        processedCoffeeOut: "Kopi yang Diproses Keluar",
        farmer: "Petani",
        farm: "Peternakan",
        plantation: "Perkebunan",
        farmers: "Petani",
        selectCrop: "Pilih Tanaman",
        farmLimitUsed: "Batas Penggunaan Peternakan",
        phoneNumber: "Nomor Telepon",
        farmSize: "Ukuran Peternakan",
        farmLocation: "Lokasi Peternakan",
        date: "Tanggal",
        status: "Status",
        noFarmers: "Tidak Ada Petani Ditemukan",
        approveReject: "Terima / Tolak",
        farms: "Peternakan",
        crops: "Tanaman",
        equipment: "Peralatan",
        noFarms: "Tidak Ada Peternakan Ditemukan",
        views: "Lihat",
        selectStatus: "Pilih Status",
        approved: "Disetujui",
        rejected: "Ditolak",
        reject: "Tolak",
        approve: "Setujui",
        conclude:"Selesaikan",
        cancel: "Batal",
        add: "Tambah",
        describeYourReason: "Deskripsikan alasan Anda di sini",
        userInformation: "Informasi Pengguna",
        userFarmRequest: "Permintaan Peternakan Pengguna",
        userFarmInformation: "Informasi Peternakan Pengguna",
        activity: "Aktivitas",
        activityType: "Tipe Aktivitas",
        farmZone: "Zona Peternakan",
        farmerView: "Tampilan Petani",
        cropType: "Tipe Tanaman",
        cropVarity: "Varietas Tanaman",
        area: "Luas",
        cost: "Biaya",
        geofence: "Geofence",
        map_views: "Tampilan Peta",
        viewAllFarms: "Lihat Semua Peternakan",
        farmersDetails: "Detail Petani",
        download: "Unduh",
        pOrder: {
          addNew: "Tambah Baru",
          viewAll: "Lihat Semua",
          selectDate: "Pilih tanggal",
          makeSelection: "Pilih salah satu",
          coffeeType: "Tipe kopi kuantitas",
          enterPrice: "Masukkan Harga",
          reqPurchaseDate: "Tanggal pembelian diperlukan",
          reqFarmer: "Petani diperlukan",
          reqCoffeeQnty: "Kuantitas Biji Kopi Cherry diperlukan",
          reqPrice: "Harga Per Kg diperlukan",
          grandTotal: "TOTAL BESAR",
          selectDateRange: "Pilih Rentang Tanggal",
          import: "Impor",
          purchaseId: "ID Pembelian",
          purchaseDate: "Tanggal Pembelian",
          farmerName: "Nama Petani",
          quality: "Kualitas",
          quantity: "Kuantitas",
          pricePerKg: "Harga Per Kg",
          selectBuyingStation: "Pilih stasiun pembelian",
          searchUser: "Cari Pengguna",
        },
        farmActivity: "Aktivitas Peternakan",
        showOnMap: "Tampilkan di Peta",
        farmInformation: "Informasi Peternakan",
        dateOfEntry: "Tanggal Masuk",
        farmID: "ID Peternakan",
        ownershipType: "Tipe Kepemilikan",
        locationAddress: "Alamat Lokasi",
        goalType: "Tipe Tujuan",
        totalSize: "Ukuran Total",
        zones: "Zona",
        farmActivities: "Aktivitas Peternakan",
        farmDetails: "Detail Peternakan",
        totalFarmsRegistered: "Total Peternakan Terdaftar",
        totalFarmArea: "Total Luas Peternakan",
        totalZone: "Total Zona",
        zone: "Zona",
        totalCost: "Total Biaya",
        selectFarmZone: "Pilih Zona / Peternakan",
        productionType: "Tipe Produksi",
        certifications: "Sertifikasi",
        geofences: "Geofences",
        farmsChart: "Grafik Peternakan",
      },
}